import { Route, Routes } from 'react-router-dom';
import { ShippingProvidersPage } from './ShippingProvidersPage';
import { ModifyShippingProviderPage } from './ModifyShippingProviderPage';

export const ShippingProviderPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifyShippingProviderPage />} />
    <Route
      path='/:shippingProviderID'
      element={<ModifyShippingProviderPage />}
    />
    <Route path='*' element={<ShippingProvidersPage />} />
  </Routes>
);
